<template>
	<div class="flow-footer" :data-border="border">
		<slot />
	</div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "Footer",
	props: {
		border: {
			type: Boolean,
			default: false
		}
	}
});
</script>
<style lang="scss">
div.flow-footer {
	flex-shrink: 0;
	overflow: hidden;
	display: flex;
	align-items: center;
	min-height: 40px;
	margin-top: auto;

	> * {
		flex: 1 0 auto;
	}
	&[data-border] {
		border-top: 1px solid var(--dashboard-border);
	}

	.button-base[state="full"] {
		min-height: 40px;
	}

	.button-base[state="full"]:only-child {
		width: 100%;
	}
}
</style>
